// Generated by scripts/build-ui-icons.mjs.
export { DotsThree as default } from "../ui/glyphs-3";
